function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import Component from '../component';
import mergeOptions from '@emav-util/merge-options.js';
import * as Fn from '@emav-util/fn.js';
import log from '@emav-util/log.js';
import { createTimeRange } from '@emav-util/time-ranges.js';
import { bufferedPercent as _bufferedPercent } from '@emav-util/buffer.js';
import MediaError from '../media-error.js';
import window from 'global/window';
import document from 'global/document';
import { isPlain } from '@emav-util/obj';
import * as TRACK_TYPES from '../tracks/track-types';
import toTitleCase from '@emav-util/to-title-case';
function createTrackHelper(self, kind, label, language) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var tracks = self.textTracks();
    options.kind = kind;
    if (label) {
        options.label = label;
    }
    if (language) {
        options.language = language;
    }
    options.tech = self;
    var track = new TRACK_TYPES.ALL.text.TrackClass(options);
    tracks.addTrack(track);
    return track;
}
var Tech = function (_Component) {
    _inherits(Tech, _Component);
    function Tech() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var ready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        };
        _classCallCheck(this, Tech);
        options.reportTouchActivity = false;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Tech).call(this, null, options, ready));
        _this.hasStarted_ = false;
        _this.on('playing', function () {
            this.hasStarted_ = true;
        });
        _this.on('loadstart', function () {
            this.hasStarted_ = false;
        });
        TRACK_TYPES.ALL.names.forEach(function (name) {
            var props = TRACK_TYPES.ALL[name];
            if (options && options[props.getterName]) {
                _this[props.privateName] = options[props.getterName];
            }
        });
        if (!_this.featuresProgressEvents) {
            _this.manualProgressOn();
        }
        if (!_this.featuresTimeupdateEvents) {
            _this.manualTimeUpdatesOn();
        }
        [
            'Text',
            'Audio',
            'Video'
        ].forEach(function (track) {
            if (options['native'.concat(track, 'Tracks')] === false) {
                _this['featuresNative'.concat(track, 'Tracks')] = false;
            }
        });
        _this.autoRemoteTextTracks_ = new TRACK_TYPES.ALL.text.ListClass();
        _this.initTrackListeners();
        if (_this.constructor) {
            _this.name_ = _this.constructor.name || 'Unknown Tech';
        }
        return _this;
    }
    _createClass(Tech, [
        {
            key: 'handleScreenshot',
            value: function handleScreenshot() {
                console.log('[Tech][handleScreenshot]:');
            }
        },
        {
            key: 'triggerSourceset',
            value: function triggerSourceset(src) {
                var _this2 = this;
                if (!this.isReady_) {
                    this.one('ready', function () {
                        return _this2.setTimeout(function () {
                            return _this2.triggerSourceset(src);
                        }, 1);
                    });
                }
                this.trigger({
                    src: src,
                    type: 'sourceset'
                });
            }
        },
        {
            key: 'manualProgressOn',
            value: function manualProgressOn() {
                this.on('durationchange', this.onDurationChange);
                this.manualProgress = true;
                this.one('ready', this.trackProgress);
            }
        },
        {
            key: 'manualProgressOff',
            value: function manualProgressOff() {
                this.manualProgress = false;
                this.stopTrackingProgress();
                this.off('durationchange', this.onDurationChange);
            }
        },
        {
            key: 'trackProgress',
            value: function trackProgress(event) {
                this.stopTrackingProgress();
                this.progressInterval = this.setInterval(Fn.bind(this, function () {
                    var numBufferedPercent = this.bufferedPercent();
                    if (this.bufferedPercent_ !== numBufferedPercent) {
                        this.trigger('progress');
                    }
                    this.bufferedPercent_ = numBufferedPercent;
                    if (numBufferedPercent === 1) {
                        this.stopTrackingProgress();
                    }
                }), 500);
            }
        },
        {
            key: 'onDurationChange',
            value: function onDurationChange(event) {
                this.duration_ = this.duration();
            }
        },
        {
            key: 'buffered',
            value: function buffered() {
                return createTimeRange(0, 0);
            }
        },
        {
            key: 'bufferedPercent',
            value: function bufferedPercent() {
                return _bufferedPercent(this.buffered(), this.duration_);
            }
        },
        {
            key: 'stopTrackingProgress',
            value: function stopTrackingProgress() {
                this.clearInterval(this.progressInterval);
            }
        },
        {
            key: 'manualTimeUpdatesOn',
            value: function manualTimeUpdatesOn() {
                this.manualTimeUpdates = true;
                this.on('play', this.trackCurrentTime);
                this.on('pause', this.stopTrackingCurrentTime);
            }
        },
        {
            key: 'manualTimeUpdatesOff',
            value: function manualTimeUpdatesOff() {
                this.manualTimeUpdates = false;
                this.stopTrackingCurrentTime();
                this.off('play', this.trackCurrentTime);
                this.off('pause', this.stopTrackingCurrentTime);
            }
        },
        {
            key: 'trackCurrentTime',
            value: function trackCurrentTime() {
                if (this.currentTimeInterval) {
                    this.stopTrackingCurrentTime();
                }
                this.currentTimeInterval = this.setInterval(function () {
                    this.trigger({
                        type: 'timeupdate',
                        target: this,
                        manuallyTriggered: true
                    });
                }, 250);
            }
        },
        {
            key: 'stopTrackingCurrentTime',
            value: function stopTrackingCurrentTime() {
                this.clearInterval(this.currentTimeInterval);
                this.trigger({
                    type: 'timeupdate',
                    target: this,
                    manuallyTriggered: true
                });
            }
        },
        {
            key: 'dispose',
            value: function dispose() {
                _get(_getPrototypeOf(Tech.prototype), 'dispose', this).call(this);
            }
        },
        {
            key: 'clearTracks',
            value: function clearTracks(types) {
                var _this3 = this;
                types = [].concat(types);
                types.forEach(function (type) {
                    var list = _this3[''.concat(type, 'Tracks')]() || [];
                    var i = list.length;
                    while (i--) {
                        var track = list[i];
                        if (type === 'text') {
                            _this3.removeRemoteTextTrack(track);
                        }
                        list.removeTrack(track);
                    }
                });
            }
        },
        {
            key: 'cleanupAutoTextTracks',
            value: function cleanupAutoTextTracks() {
                var list = this.autoRemoteTextTracks_ || [];
                var i = list.length;
                while (i--) {
                    var track = list[i];
                    this.removeRemoteTextTrack(track);
                }
            }
        },
        {
            key: 'reset',
            value: function reset() {
            }
        },
        {
            key: 'error',
            value: function error(err) {
                if (err !== undefined) {
                    this.error_ = new MediaError(err);
                    this.trigger('error');
                }
                return this.error_;
            }
        },
        {
            key: 'played',
            value: function played() {
                if (this.hasStarted_) {
                    return createTimeRange(0, 0);
                }
                return createTimeRange();
            }
        },
        {
            key: 'setCurrentTime',
            value: function setCurrentTime() {
                if (this.manualTimeUpdates) {
                    this.trigger({
                        type: 'timeupdate',
                        target: this,
                        manuallyTriggered: true
                    });
                }
            }
        },
        {
            key: 'initTrackListeners',
            value: function initTrackListeners() {
                var _this4 = this;
                TRACK_TYPES.NORMAL.names.forEach(function (name) {
                    var props = TRACK_TYPES.NORMAL[name];
                    var trackListChanges = function trackListChanges() {
                        _this4.trigger(''.concat(name, 'trackchange'));
                    };
                    var tracks = _this4[props.getterName]();
                    tracks.addEventListener('removetrack', trackListChanges);
                    tracks.addEventListener('addtrack', trackListChanges);
                    _this4.on('dispose', function () {
                        tracks.removeEventListener('removetrack', trackListChanges);
                        tracks.removeEventListener('addtrack', trackListChanges);
                    });
                });
            }
        },
        {
            key: 'addTextTrack',
            value: function addTextTrack(kind, label, language) {
                if (!kind) {
                    throw new Error('TextTrack kind is required but was not provided');
                }
                return createTrackHelper(this, kind, label, language);
            }
        },
        {
            key: 'createRemoteTextTrack',
            value: function createRemoteTextTrack(options) {
                var track = mergeOptions(options, { tech: this });
                return new TRACK_TYPES.REMOTE.remoteTextEl.TrackClass(track);
            }
        },
        {
            key: 'addRemoteTextTrack',
            value: function addRemoteTextTrack() {
                var _this5 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var manualCleanup = arguments.length > 1 ? arguments[1] : undefined;
                var htmlTrackElement = this.createRemoteTextTrack(options);
                if (manualCleanup !== true && manualCleanup !== false) {
                    log.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of emav.js');
                    manualCleanup = true;
                }
                this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
                this.remoteTextTracks().addTrack(htmlTrackElement.track);
                if (manualCleanup !== true) {
                    this.ready(function () {
                        return _this5.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
                    });
                }
                return htmlTrackElement;
            }
        },
        {
            key: 'removeRemoteTextTrack',
            value: function removeRemoteTextTrack(track) {
                var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
                this.remoteTextTrackEls().removeTrackElement_(trackElement);
                this.remoteTextTracks().removeTrack(track);
                this.autoRemoteTextTracks_.removeTrack(track);
            }
        },
        {
            key: 'getVideoPlaybackQuality',
            value: function getVideoPlaybackQuality() {
                return {};
            }
        },
        {
            key: 'setPoster',
            value: function setPoster() {
            }
        },
        {
            key: 'playsinline',
            value: function playsinline() {
            }
        },
        {
            key: 'setPlaysinline',
            value: function setPlaysinline() {
            }
        },
        {
            key: 'overrideNativeAudioTracks',
            value: function overrideNativeAudioTracks() {
            }
        },
        {
            key: 'overrideNativeVideoTracks',
            value: function overrideNativeVideoTracks() {
            }
        },
        {
            key: 'canPlayType',
            value: function canPlayType() {
                return '';
            }
        }
    ], [
        {
            key: 'canPlayType',
            value: function canPlayType() {
                return '';
            }
        },
        {
            key: 'canPlaySource',
            value: function canPlaySource(srcObj, options) {
                return Tech.canPlayType(srcObj.type);
            }
        },
        {
            key: 'isTech',
            value: function isTech(component) {
                return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
            }
        },
        {
            key: 'registerTech',
            value: function registerTech(name, tech) {
                if (!Tech.techs_) {
                    Tech.techs_ = {};
                }
                if (!Tech.isTech(tech)) {
                    throw new Error('Tech '.concat(name, ' must be a Tech'));
                }
                if (!Tech.canPlayType) {
                    throw new Error('Techs must have a static canPlayType method on them');
                }
                if (!Tech.canPlaySource) {
                    throw new Error('Techs must have a static canPlaySource method on them');
                }
                name = toTitleCase(name);
                Tech.techs_[name] = tech;
                if (name !== 'Tech') {
                    Tech.defaultTechOrder_.push(name);
                }
                return tech;
            }
        },
        {
            key: 'getTech',
            value: function getTech(name) {
                if (!name) {
                    return;
                }
                name = toTitleCase(name);
                if (Tech.techs_ && Tech.techs_[name]) {
                    return Tech.techs_[name];
                }
                if (window && window.emav && window.emav[name]) {
                    log.warn('The '.concat(name, ' tech was added to the emav object when it should be registered using emav.registerTech(name, tech)'));
                    return window.emav[name];
                }
            }
        }
    ]);
    return Tech;
}(Component);
TRACK_TYPES.ALL.names.forEach(function (name) {
    var props = TRACK_TYPES.ALL[name];
    Tech.prototype[props.getterName] = function () {
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
Tech.prototype.featuresVolumeControl = true;
Tech.prototype.featuresMuteControl = true;
Tech.prototype.featuresFullscreenResize = false;
Tech.prototype.featuresPlaybackRate = false;
Tech.prototype.featuresProgressEvents = false;
Tech.prototype.featuresSourceset = false;
Tech.prototype.featuresTimeupdateEvents = false;
Tech.prototype.featuresNativeTextTracks = false;
Tech.withSourceHandlers = function (_Tech) {
    _Tech.registerSourceHandler = function (handler, index) {
        var handlers = _Tech.sourceHandlers;
        if (!handlers) {
            handlers = _Tech.sourceHandlers = [];
        }
        if (index === undefined) {
            index = handlers.length;
        }
        handlers.splice(index, 0, handler);
    };
    _Tech.canPlayType = function (type) {
        var handlers = _Tech.sourceHandlers || [];
        var can;
        for (var i = 0; i < handlers.length; i++) {
            can = handlers[i].canPlayType(type);
            if (can) {
                return can;
            }
        }
        return '';
    };
    _Tech.selectSourceHandler = function (source, options) {
        var handlers = _Tech.sourceHandlers || [];
        var can;
        for (var i = 0; i < handlers.length; i++) {
            can = handlers[i].canHandleSource(source, options);
            if (can) {
                return handlers[i];
            }
        }
        return null;
    };
    _Tech.canPlaySource = function (srcObj, options) {
        var sh = _Tech.selectSourceHandler(srcObj, options);
        if (sh) {
            return sh.canHandleSource(srcObj, options);
        }
        return '';
    };
    var deferrable = [
        'seekable',
        'seeking',
        'duration'
    ];
    deferrable.forEach(function (fnName) {
        var originalFn = this[fnName];
        if (typeof originalFn !== 'function') {
            return;
        }
        this[fnName] = function () {
            if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
                return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
            }
            return originalFn.apply(this, arguments);
        };
    }, _Tech.prototype);
    _Tech.prototype.setSource = function (source) {
        var sh = _Tech.selectSourceHandler(source, this.options_);
        if (!sh) {
            if (_Tech.nativeSourceHandler) {
                sh = _Tech.nativeSourceHandler;
            } else {
                log.error('No source handler found for the current source.');
            }
        }
        this.disposeSourceHandler();
        this.off('dispose', this.disposeSourceHandler);
        if (sh !== _Tech.nativeSourceHandler) {
            this.currentSource_ = source;
        }
        this.sourceHandler_ = sh.handleSource(source, this, this.options_);
        this.on('dispose', this.disposeSourceHandler);
    };
    _Tech.prototype.disposeSourceHandler = function () {
        if (this.currentSource_) {
            this.clearTracks([
                'audio',
                'video'
            ]);
            this.currentSource_ = null;
        }
        this.cleanupAutoTextTracks();
        if (this.sourceHandler_) {
            if (this.sourceHandler_.dispose) {
                this.sourceHandler_.dispose();
            }
            this.sourceHandler_ = null;
        }
    };
};
Tech.registerTech('Tech', Tech);
Tech.defaultTechOrder_ = [];
export default Tech;